// extracted by mini-css-extract-plugin
export default {"image":"MobileMealImage_image__jJQZW","image--no-image":"MobileMealImage_image--no-image__yEuYz","image--sold-out":"MobileMealImage_image--sold-out__VK-CK"};